export let SET_LOGIN_CREDENTIALS = 'SET_CREDENTIALS';
export let SET_LOGIN_STATE = 'SET_LOGIN_STATE';
export let SET_USER_DATA = 'SET_USER_DATA';
export let SET_HEADER = 'SET_HEADER';
export let SET_APP_STATE = 'SET_APP_STATE';

export let LOGIN_STATES = {
    CONNECTION_ERROR: 'CONNECTION_ERROR',
    TRY_LOGIN: 'TRY_LOGIN',
    LOGGED_IN: 'LOGGED_IN',
    NOT_LOGGED_IN: 'NOT_LOGGED_IN',
};

export let APP_STATE = {
    INITIALISING: 'INITIALISING',
    INITIALISED: 'INITIALISED',
};

export function setLoginCredentials(user, token) {
    return {
        type: SET_LOGIN_CREDENTIALS,
        user,
        token,
    }
}

export function setLoginState(state) {
    return {
        type: SET_LOGIN_STATE,
        state,
    }
}

export function setUserData(access) {
    return {
        type: SET_USER_DATA,
        access,
    }
}

export function setHeader(title, icon) {
    return {
        type: SET_HEADER,
        title,
        icon,
    }
}

export function setAppState(state) {
    return {
        type: SET_APP_STATE,
        state,
    }
}

